"use client";

import { FC } from "react";
import type { PaginationProps } from "antd/es/pagination";
import CustomIcon from "@/components/ui/custom-icon";
import { useTranslations } from "next-intl";
import Pagination from "antd/lib/pagination";
import clsx from "clsx";
import { Button } from "@/components/ui/button";
import S from "./index.module.scss";

interface IPager {
  total: number;
  activePageNumber: number;
  activePageSize: number;
  onPageChangeHandler(page: number): void;
  onShowMoreChangeHandler?(page: number): void;
}

const Pager: FC<IPager> = ({
  activePageSize,
  activePageNumber,
  onPageChangeHandler,
  onShowMoreChangeHandler,
  total,
}) => {
  const t = useTranslations("news");

  const itemRender: PaginationProps["itemRender"] = (_, type, originalElement) => {
    if (type === "prev") {
      return (
        <span className={clsx(S.dirWrapper, { [S["dirWrapper--prev"]]: true })}>
          <CustomIcon fileName={"icon-nav-arrow"} />
        </span>
      );
    }
    if (type === "next") {
      return (
        <span className={S.dirWrapper}>
          <CustomIcon fileName={"icon-nav-arrow"} />
        </span>
      );
    }
    return originalElement;
  };

  const pageChanger = (page: number) => {
    onPageChangeHandler(page);
  };

  return (
    <div className={S.pagerContainer}>
      {onShowMoreChangeHandler && activePageNumber < total / activePageSize && (
        <Button onClick={() => onShowMoreChangeHandler(activePageNumber + 1)}>{t("showMore")}</Button>
      )}
      <Pagination
        current={activePageNumber}
        defaultPageSize={activePageSize}
        total={total}
        showLessItems
        itemRender={itemRender}
        hideOnSinglePage
        showSizeChanger={false}
        showTitle={false}
        onChange={page => pageChanger(page)}
      />
    </div>
  );
};

export default Pager;
